import { ICustomerContact } from '@typings'

export const formatCustomerContactName = (
  customerContact: ICustomerContact
) => {
  return `${customerContact.firstname} ${customerContact.lastname}`
}
